module.exports = new __parcel__URL__("LeftLobby.d2f5f3d5.hdr").toString();